import { useEffect, useRef } from "react"
import { createPortal } from "react-dom"
import "./SucessoServicoFinalizado.css"
import { tocarSomSucesso } from "./somSucessoServico"

/**
 * Tela cheia de sucesso, no estilo da confirmação do Mercado Livre.
 * @param {string} mensagem Texto vindo da API
 * @param {() => void} onConcluir Chamado ao toque ou ao fim da animação
 * @param {boolean} manual Se true, não avança sozinho (prévia)
 */
export default function SucessoServicoFinalizado({ mensagem, onConcluir, manual = false }) {
	const concluirRef = useRef(onConcluir)
	const liberado = useRef(false)
	concluirRef.current = onConcluir

	useEffect(() => {
		tocarSomSucesso()

		const liberar = setTimeout(() => {
			liberado.current = true
		}, 700)

		if (manual) return () => clearTimeout(liberar)

		// A animação termina por volta de 1,3s. A partir daí, espera 3s com a tela pronta.
		const seguir = setTimeout(() => concluirRef.current?.(), 1300 + 3000)
		return () => {
			clearTimeout(liberar)
			clearTimeout(seguir)
		}
	}, [manual])

	const { titulo, detalhe } = textosSucesso(mensagem)

	return createPortal(
		<button
			type="button"
			className="sucesso-servico"
			onClick={() => {
				if (liberado.current) concluirRef.current?.()
			}}
			aria-live="polite"
		>
			<div className="sucesso-servico__conteudo">
				<div className="sucesso-servico__badge" aria-hidden>
					<svg viewBox="0 0 120 120" className="sucesso-servico__svg">
						<circle className="sucesso-servico__aro" cx="60" cy="60" r="54" />
						<circle className="sucesso-servico__miolo" cx="60" cy="60" r="40" />
						<path className="sucesso-servico__visto" d="M40 62 l13 13 l27-30" />
					</svg>
				</div>
				<h1 className="sucesso-servico__titulo">{titulo}</h1>
				{detalhe ? <p className="sucesso-servico__detalhe">{detalhe}</p> : null}
			</div>
			{manual ? <span className="sucesso-servico__dica">Prévia · toque para voltar</span> : null}
		</button>,
		document.body
	)
}

function textosSucesso(mensagem) {
	const texto = typeof mensagem === "string" ? mensagem.trim() : ""
	const titulo = "Serviço finalizado"
	if (!texto) return { titulo, detalhe: "" }

	const simples = texto
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")

	if (
		simples === "servico finalizado" ||
		simples === "servico finalizado com sucesso" ||
		simples === "servico finalizado com sucesso." ||
		simples === "sucesso" ||
		simples === "sucesso!"
	) {
		return { titulo, detalhe: "" }
	}

	return { titulo, detalhe: texto }
}
